import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FenceMaterialsComponent } from './materials.component';
import { MaterialsBoardsComponent } from './materials-boards/materials-boards.component';
import { MaterialsDecorsComponent } from './materials-decors/materials-decors.component';
import { MaterialsDoorsComponent } from './materials-doors/materials-doors.component';
import { MaterialsPanelsComponent } from './materials-panels/materials-panels.component';
import { MaterialsPostsComponent } from './materials-posts/materials-posts.component';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '../../../../ui/loader/loader.component';
import { FenceSidePanelCountComponent } from './side-panel-count/side-panel-count.component';
import { TooltipDirective } from '../../../../services/directives/tooltip-directive';
import { FormsModule } from '@angular/forms';
import { MaterialsInstallationsComponent } from './materials-installations/materials-installations.component';
import { MaterialsDecorativeBoardsComponent } from './materials-decorative-boards/materials-decorative-boards.component';
import {
  MaterialsInstallationMixingsComponent
} from './materials-installations/materials-installation-mixings/materials-installation-mixings.component';
import {
  MaterialsInstallationSimplesComponent
} from './materials-installations/materials-installation-simples/materials-installation-simples.component';
import {
  MaterialsInstallationBoardsComponent
} from './materials-boards/materials-installation-boards/materials-installation-boards.component';

@NgModule({
  declarations: [
    MaterialsInstallationsComponent,
    MaterialsInstallationSimplesComponent,
    MaterialsInstallationMixingsComponent,
    MaterialsInstallationBoardsComponent,
    FenceMaterialsComponent,
    MaterialsBoardsComponent,
    MaterialsDecorativeBoardsComponent,
    MaterialsDecorsComponent,
    MaterialsDoorsComponent,
    MaterialsPanelsComponent,
    MaterialsPostsComponent,
    FenceSidePanelCountComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    LoaderComponent,
    TooltipDirective,
    FormsModule,
  ],
  exports: [FenceMaterialsComponent],
})
export class FenceMaterialsModule {}
